var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "7B1D8572-090D-422A-8FAE-992FF3495178")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssetSheet",
    transform: "translate(-903.000000, -91.000000)",
    fill: "#001B2B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917,91 C918.656854,91 920,92.3431458 920,94 L920,94 L920,97.056 L925.418762,93.1862665 C926.049113,92.7360159 926.913025,93.1437129 926.993873,93.8861839 L927,94 L927,104 C927,104.813373 926.08063,105.286497 925.418762,104.813733 L925.418762,104.813733 L920,100.943 L920,104 C920,105.597681 918.75108,106.903661 917.176273,106.994907 L917,107 L906,107 C904.343146,107 903,105.656854 903,104 L903,104 L903,94 C903,92.3431458 904.343146,91 906,91 L906,91 Z M917,93 L906,93 C905.447715,93 905,93.4477153 905,94 L905,94 L905,104 C905,104.552285 905.447715,105 906,105 L906,105 L917,105 C917.552285,105 918,104.552285 918,104 L918,104 L918.000129,99.0161658 C917.999958,99.0054362 917.999957,98.9947043 918.000127,98.9839747 L918,94 C918,93.4477153 917.552285,93 917,93 L917,93 Z M925,95.942 L920.72,99 L925,102.057 L925,95.942 Z",
    id: "Combined-Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Camera.62e77ba8.svg";
export { ForwardRef as ReactComponent };